import React from 'react';
import Seo from '../../components/utils/Seo';
import BodyContactPage from './body/BodyContactPage'
import Footer from '../../components/marketing/footer/Footer';
import NavBar from '../../components/marketing/navbar/NavBar';
import HeaderContact from '../../components/marketing/pageSections/contact/HeaderContact';


function Contact(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Contactez votre expert en traduction des langues"
                description="Rita traduis des documents, sites web et autres en anglais, français et espagnol discutons pour votre problème de traduction"
            />
            <NavBar />
            <HeaderContact />
            <BodyContactPage />
            <Footer />
        </div>
    );
}

export default Contact;